// extracted by mini-css-extract-plugin
module.exports = {"mappedAnnounces":"Contests-module--mappedAnnounces--3W5p6"};